export function closestIdContainingString({
  element,
  idSubstring,
  stopAtParentId
}: {
  element: HTMLElement | null
  idSubstring: string
  stopAtParentId?: string
}): HTMLElement | null {
  while (element) {
    if (element.id && element.id.includes(idSubstring)) {
      return element
    }
    if (stopAtParentId && element.id === stopAtParentId) {
      break
    }
    element = element.parentElement
  }
  return null
}
